import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    accounting: 'advanced accounting features.',
    changePlan: 'Change plan',
    insurances: 'exclusive insurance;',
    limits: 'higher limits;',
    moves: 'more transfers included;',
    subTitle: 'and much more:',
    title: 'Add your logo to your quotes and invoices',
  },
  fr: {
    accounting: 'des fonctionnalités comptables avancées.',
    changePlan: 'Changer d’offre',
    insurances: 'des assurances exclusives\xa0;',
    limits: 'des plafonds plus élevés\xa0;',
    moves: 'plus de mouvements inclus\xa0;',
    subTitle: 'et bien plus encore\xa0:',
    title: 'Ajoutez votre logo sur vos devis et factures',
  },
} as const);

export default locales;
